import * as React from 'react';
import { createPropsGetter } from './Hoc/createPropsGetter';

type Env = 'production' | 'development' | 'test';

const initialState = {};
const defaultProps = {
  envLevel: ['development'] as Env[],
};

type State = Readonly<typeof initialState>;
type DefaultProps = typeof defaultProps;
type Props = Partial<DefaultProps> & {
  condition?: boolean;
};

const getProps = createPropsGetter(defaultProps);

class EnvBox extends React.PureComponent<Props, State> {
  static defaultProps = defaultProps;

  readonly state = initialState;

  render() {
    const { envLevel, children, condition, ...restProps } = getProps(this.props);

    const currentEnv = this.getEnv();
    let wrapChildren = null as any;

    if (Array.isArray(children)) {
      wrapChildren = React.Children.map(children, (child, idx) => {
        child = React.Children.only(child);
        child = React.cloneElement(child, { ...restProps });
        return child;
      });
    } else {
      const child = React.Children.only(children);
      wrapChildren = React.cloneElement(child, { ...restProps });
    }

    if (envLevel.includes(currentEnv)) return wrapChildren;

    if (condition) return wrapChildren;

    return null;
  }

  getEnv = () => {
    return process.env.NODE_ENV as Env;
  };
}

export default EnvBox;
